
import React from "react";
import { useState, useEffect } from "react";
import "./DeliveryInvoiceEdit.css";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

import { openPopup } from "../../stateManagement/actions/popupActions";
import { DeliveryInvoiceBatchDetails, SalesReasonDetails } from "../../types/types";
import DeliveryInvoiceReasonSelection from "./DeliveryInvoiceReasonSelection";
import { useLocation } from "react-router-dom";
import { batch } from "react-redux";


const DeliveryInvoiceReasonSelectionParent = (props: {batchData: DeliveryInvoiceBatchDetails, ignoreValidation?: boolean, updateParent?: () => void , disabledUoms: string[], otherUnitName ?: string, isRestrictedSku?: boolean}) => {
  const location: { state: any } = useLocation();
  const productDetails: any = location.state?.productDetails;
  const [reasonList, setReasonList] = useState<SalesReasonDetails[]>([]);

  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
  const reasonMap: { [key: string]: string[] } = ConfigDictionary?.salesReturnReasonsMap ?? {};

  useEffect(() => {
    if (!props.batchData.reasonDetails || props.batchData.reasonDetails.length === 0) {
      setReasonList([{
        caseQty: 0, pieceQty: 0, reason: "", otherQty: 0
      }])
    } else {
      setReasonList([...props.batchData.reasonDetails]);
    }
  }, [props.batchData])

  useEffect(() => {
    props.batchData.reasonDetails = reasonList;
  }, [reasonList]);

  const convertToPieceQty = (qty: number, key: "pieceQty" | "caseQty" | "otherQty") => {
    switch (key) {
      case "pieceQty": return qty;
      case "caseQty": return productDetails ? productDetails.caseToPieceQuantity * qty : qty;
      case "otherQty": return productDetails ? productDetails.otherUnitToPieceQuantity * qty : qty;
    }

  }

  const getNormalisedQty = (caseQty: number, pieceQty: number, otherQty: number) => {
    let qty = pieceQty;
    qty += productDetails ? productDetails.caseToPieceQuantity * caseQty : caseQty;
    qty += productDetails ? productDetails.otherUnitToPieceQuantity * otherQty : otherQty;
    return qty;
  }

  const getCurrentAggregatedNormalisedQty = (reasonList: SalesReasonDetails[]) => {
    const prevAggQty = reasonList.reduce((acc, curr) => acc + getNormalisedQty(curr.caseQty, curr.pieceQty, curr.otherQty), 0);
    return prevAggQty;
  }

  const validateQuantity = (qty: number, prevQty: number, key: "pieceQty" | "caseQty" | "otherQty") => {
    if (props.ignoreValidation) {
      return;
    }
    const allowedQty = getNormalisedQty(props.batchData.caseQty, props.batchData.pieceQty, props.batchData.otherQty);
    const currentQty = getCurrentAggregatedNormalisedQty(reasonList) + convertToPieceQty(qty, key) - convertToPieceQty(prevQty, key);
    if (currentQty > allowedQty) {
      openPopup("Error", "Return quantity cannot exceed ordered quantity");
      throw Error("Return quantity cannot exceed ordered quantity");
    }
  }

  const removeIcon = (index:number)=>{
    return <RemoveCircleOutlineIcon
    onClick={() => {
      const newList = [...reasonList];
      newList.splice(index, 1);
      if (newList.length == 0) {
        setReasonList([{
          caseQty: 0, pieceQty: 0, otherQty: 0, reason: ""
        }]);
      } else {
        setReasonList(newList);
      }
    }}
    style={{
      cursor: "pointer",
      color: "#C44C36",
    }}
  />
  }

  const addIcon = ()=>{
    return <AddCircleOutlineIcon
      style={{
        cursor: "pointer",
        color: "#227C9D",
        strokeWidth: 2,
      }}
      onClick={() => {
        const newList = [...reasonList];
        newList.push({ reason: "", caseQty: 0, pieceQty: 0, otherQty: 0 });
        setReasonList(newList);
      }}
    />
  }

  return (
    <div className="delivery-reasons-container">
      {reasonList.map((reason: SalesReasonDetails, index: number) => {
        return (

          <div className="delivery-sku-edit-list-item" key={index}>
            <DeliveryInvoiceReasonSelection isRestrictedSku = {props.isRestrictedSku} otherUnitName= {props.otherUnitName} validate={validateQuantity} reasonObject={reason} actionElement={reasonList.length >= 2 ? removeIcon(index) : addIcon()} onChange={(data: SalesReasonDetails) => {

              const newReasonList = [...reasonList];
              newReasonList[index].pieceQty = data.pieceQty ?? 0;
              newReasonList[index].caseQty = data.caseQty ?? 0;
              newReasonList[index].otherQty = data.otherQty ?? 0;
              newReasonList[index].reason = data.reason ?? "";
              newReasonList[index].saleCondition = data.saleCondition ?? "";
              setReasonList(newReasonList);
              if (props.updateParent) {
                props.batchData.caseQty = reasonList.reduce((total, reason) => total + (reason.caseQty || 0), 0);
                props.batchData.pieceQty = reasonList.reduce((total, reason) => total + (reason.pieceQty || 0), 0);
                props.batchData.otherQty = reasonList.reduce((total, reason) => total + (reason.otherQty || 0), 0);
                props.updateParent();
              }
            }} 
            disabledUoms={props.disabledUoms}
            />
            {Object.keys(reasonMap).length == 0 ? reasonList.length >= 2 ? removeIcon(index) : addIcon() : <></>}
          </div>

        );
      })}
      <div className="delivery-batch-edit-add-more" style={{marginTop:Object.keys(reasonMap).length == 0 ? "0px" : "18px"}}>
        {reasonList.length >= 2 && addIcon()}
      </div>
    </div>
  );
}

export default DeliveryInvoiceReasonSelectionParent;